import ErrorManager from '@/common/utils/ErrorManager';
import { ERROR } from '@/modules/ErrorToaster/store/mutation-types';
import { RootState } from '@/plugins/store';
import { ActionTree } from 'vuex';
import { ReglementFournisseurState } from '@/modules/ReglementsFournisseurs/store/state';
import {
    ReglementFournisseurActions,
    ReglementFournisseurActionType
} from '@/modules/ReglementsFournisseurs/store/action-types';
import { REGLEMENT_FOURNISSEUR } from '@/modules/ReglementsFournisseurs/store/mutation-types';
import ReglementService, {
    FilterReglementFournisseur
} from '@/modules/ReglementsFournisseurs/services/ReglementService';


export const actions: ActionTree<ReglementFournisseurState, RootState> = {

    async [ReglementFournisseurActions.GET_REGLEMENTS]({ commit }: ReglementFournisseurActionType, payload: FilterReglementFournisseur): Promise<void> {
        commit(REGLEMENT_FOURNISSEUR.SET_REGLEMENTS_LOADING, true);
        commit(REGLEMENT_FOURNISSEUR.SET_PAGE, payload.page);

        ReglementService.getReglements(payload)
            .then(async (response: any) => {
                if (response !== undefined || response?.status !== undefined) {
                    if (response.status !== 200) {
                        commit(`errorToaster/${ERROR.SET_MESSAGE}`,
                            await ErrorManager.processErrorCustomMessage(
                                response.status,
                                'app.error.undefined'
                            ),
                            { root: true }
                        );
                    }
                    if (payload.page === 0 ){
                        commit(REGLEMENT_FOURNISSEUR.SET_REGLEMENTS, response.data.content);
                        commit(REGLEMENT_FOURNISSEUR.SET_NUMBER_OF_PAGES, response.data.totalPages);
                        commit(REGLEMENT_FOURNISSEUR.SET_NB_ELEMENTS, response.data.totalElements);
                    } else {
                        commit(REGLEMENT_FOURNISSEUR.ADD_REGLEMENTS, response.data.content);
                    }
                } else {
                    commit(
                        `errorToaster/${ERROR.SET_MESSAGE}`,
                        await ErrorManager.processErrorCustomMessage(
                            response.status,
                            'app.error.undefined'
                        ),
                        { root: true }
                    );
                }
                commit(REGLEMENT_FOURNISSEUR.SET_REGLEMENTS_LOADING, false);
            }).catch(async error => {
                commit(
                    `errorToaster/${ERROR.SET_MESSAGE}`,
                    await ErrorManager.processError(error),
                    { root: true }
                );
            commit(REGLEMENT_FOURNISSEUR.SET_REGLEMENTS_LOADING, false);

        });
    },
    async [ReglementFournisseurActions.GET_XLS]({ commit }: ReglementFournisseurActionType, payload: FilterReglementFournisseur): Promise<void> {
        commit(REGLEMENT_FOURNISSEUR.XLS_LOADING, true);
        try {
            const response = await ReglementService.getReglementXls(payload);
            if (response.status === 200 && response.data !== undefined) {
                const blob = new Blob([response.data], { type: response.headers['content-type'] });
                const link = document.createElement('a');
                link.href = window.URL.createObjectURL(blob);
                link.download = 'export_reglements.xlsx';
                link.click();
                URL.revokeObjectURL(link.href);
            } else {
                commit(
                    `errorToaster/${ERROR.SET_MESSAGE}`,
                    await ErrorManager.processErrorCustomMessage(response.status, 'app.error.undefined'),
                    { root: true }
                );
            }
            commit(REGLEMENT_FOURNISSEUR.XLS_LOADING, false);
        } catch (error) {
            commit(REGLEMENT_FOURNISSEUR.XLS_LOADING, false);
            commit(`errorToaster/${ERROR.SET_MESSAGE}`, await ErrorManager.processError(error), { root: true });
        }
    }
};
